import { dynamicUseCase } from "@/utils/dynamic-use-case";
import { useCaseMapping } from "@/utils/use-case-mapping";

/* Prop Types */
interface StudyIconProps {
  useCase: {
    name: string;
  };
}

/*
 * StudyIcon component
 * Renders a study icon with a background color based on the use case
 */
export const StudyIcon = ({ useCase }: StudyIconProps) => {
  /* Render */
  return (
    <div className={`flex items-center justify-center size-12 shrink-0 rounded-lg bg-${useCaseMapping[useCase.name]?.color}`}>
      {dynamicUseCase(useCase.name, "size-6 text-white")}
    </div>
  );
};
